// source: proto/usrpb/registration.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_type_date_pb = require('../../google/type/date_pb.js');
goog.object.extend(proto, google_type_date_pb);
goog.exportSymbol('proto.usrpb.CorpAttachments', null, global);
goog.exportSymbol('proto.usrpb.CorpAttachmentsResponse', null, global);
goog.exportSymbol('proto.usrpb.GetRegistrationAccountRequest', null, global);
goog.exportSymbol('proto.usrpb.Registration', null, global);
goog.exportSymbol('proto.usrpb.RegistrationAccount', null, global);
goog.exportSymbol('proto.usrpb.RegistrationAssociation', null, global);
goog.exportSymbol('proto.usrpb.RegistrationCorpPrimaryAgentAddress', null, global);
goog.exportSymbol('proto.usrpb.RegistrationEmployment', null, global);
goog.exportSymbol('proto.usrpb.RegistrationIdentification', null, global);
goog.exportSymbol('proto.usrpb.RegistrationObjective', null, global);
goog.exportSymbol('proto.usrpb.RegistrationOwner', null, global);
goog.exportSymbol('proto.usrpb.RegistrationTrustedContact', null, global);
goog.exportSymbol('proto.usrpb.SaveOnboardingPercentRequest', null, global);
goog.exportSymbol('proto.usrpb.SaveRegistrationDisclosureRequest', null, global);
goog.exportSymbol('proto.usrpb.SaveRegistrationIdentificationRequest', null, global);
goog.exportSymbol('proto.usrpb.SaveRegistrationKycRequest', null, global);
goog.exportSymbol('proto.usrpb.SaveRegistrationTradingRequest', null, global);
goog.exportSymbol('proto.usrpb.SignRegistrationRequest', null, global);
goog.exportSymbol('proto.usrpb.VerifyRegistrationRequest', null, global);
goog.exportSymbol('proto.usrpb.VerifyRegistrationResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usrpb.Registration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.usrpb.Registration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usrpb.Registration.displayName = 'proto.usrpb.Registration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usrpb.VerifyRegistrationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.usrpb.VerifyRegistrationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usrpb.VerifyRegistrationRequest.displayName = 'proto.usrpb.VerifyRegistrationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usrpb.VerifyRegistrationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.usrpb.VerifyRegistrationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usrpb.VerifyRegistrationResponse.displayName = 'proto.usrpb.VerifyRegistrationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usrpb.RegistrationOwner = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.usrpb.RegistrationOwner, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usrpb.RegistrationOwner.displayName = 'proto.usrpb.RegistrationOwner';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usrpb.RegistrationEmployment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.usrpb.RegistrationEmployment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usrpb.RegistrationEmployment.displayName = 'proto.usrpb.RegistrationEmployment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usrpb.RegistrationAssociation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.usrpb.RegistrationAssociation.repeatedFields_, null);
};
goog.inherits(proto.usrpb.RegistrationAssociation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usrpb.RegistrationAssociation.displayName = 'proto.usrpb.RegistrationAssociation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usrpb.RegistrationIdentification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.usrpb.RegistrationIdentification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usrpb.RegistrationIdentification.displayName = 'proto.usrpb.RegistrationIdentification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usrpb.RegistrationObjective = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.usrpb.RegistrationObjective, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usrpb.RegistrationObjective.displayName = 'proto.usrpb.RegistrationObjective';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usrpb.RegistrationTrustedContact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.usrpb.RegistrationTrustedContact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usrpb.RegistrationTrustedContact.displayName = 'proto.usrpb.RegistrationTrustedContact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usrpb.RegistrationCorpPrimaryAgentAddress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.usrpb.RegistrationCorpPrimaryAgentAddress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usrpb.RegistrationCorpPrimaryAgentAddress.displayName = 'proto.usrpb.RegistrationCorpPrimaryAgentAddress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usrpb.RegistrationAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.usrpb.RegistrationAccount.repeatedFields_, null);
};
goog.inherits(proto.usrpb.RegistrationAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usrpb.RegistrationAccount.displayName = 'proto.usrpb.RegistrationAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usrpb.SaveOnboardingPercentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.usrpb.SaveOnboardingPercentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usrpb.SaveOnboardingPercentRequest.displayName = 'proto.usrpb.SaveOnboardingPercentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usrpb.SaveRegistrationIdentificationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.usrpb.SaveRegistrationIdentificationRequest.repeatedFields_, null);
};
goog.inherits(proto.usrpb.SaveRegistrationIdentificationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usrpb.SaveRegistrationIdentificationRequest.displayName = 'proto.usrpb.SaveRegistrationIdentificationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usrpb.SaveRegistrationTradingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.usrpb.SaveRegistrationTradingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usrpb.SaveRegistrationTradingRequest.displayName = 'proto.usrpb.SaveRegistrationTradingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usrpb.SaveRegistrationDisclosureRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.usrpb.SaveRegistrationDisclosureRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usrpb.SaveRegistrationDisclosureRequest.displayName = 'proto.usrpb.SaveRegistrationDisclosureRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usrpb.SignRegistrationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.usrpb.SignRegistrationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usrpb.SignRegistrationRequest.displayName = 'proto.usrpb.SignRegistrationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usrpb.GetRegistrationAccountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.usrpb.GetRegistrationAccountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usrpb.GetRegistrationAccountRequest.displayName = 'proto.usrpb.GetRegistrationAccountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usrpb.SaveRegistrationKycRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.usrpb.SaveRegistrationKycRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usrpb.SaveRegistrationKycRequest.displayName = 'proto.usrpb.SaveRegistrationKycRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usrpb.CorpAttachments = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.usrpb.CorpAttachments, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usrpb.CorpAttachments.displayName = 'proto.usrpb.CorpAttachments';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usrpb.CorpAttachmentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.usrpb.CorpAttachmentsResponse.repeatedFields_, null);
};
goog.inherits(proto.usrpb.CorpAttachmentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usrpb.CorpAttachmentsResponse.displayName = 'proto.usrpb.CorpAttachmentsResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usrpb.Registration.prototype.toObject = function(opt_includeInstance) {
  return proto.usrpb.Registration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usrpb.Registration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.Registration.toObject = function(includeInstance, msg) {
  var f, obj = {
    verificationKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    firstName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    middleName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    email: jspb.Message.getFieldWithDefault(msg, 5, ""),
    password: jspb.Message.getFieldWithDefault(msg, 6, ""),
    securityWord: jspb.Message.getFieldWithDefault(msg, 7, ""),
    securityWordHint: jspb.Message.getFieldWithDefault(msg, 8, ""),
    promoCode: jspb.Message.getFieldWithDefault(msg, 9, ""),
    phoneNumber: jspb.Message.getFieldWithDefault(msg, 10, ""),
    suffix: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usrpb.Registration}
 */
proto.usrpb.Registration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usrpb.Registration;
  return proto.usrpb.Registration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usrpb.Registration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usrpb.Registration}
 */
proto.usrpb.Registration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVerificationKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMiddleName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityWord(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityWordHint(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPromoCode(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneNumber(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setSuffix(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usrpb.Registration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usrpb.Registration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usrpb.Registration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.Registration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVerificationKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMiddleName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSecurityWord();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSecurityWordHint();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPromoCode();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPhoneNumber();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getSuffix();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional string verification_key = 1;
 * @return {string}
 */
proto.usrpb.Registration.prototype.getVerificationKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.Registration} returns this
 */
proto.usrpb.Registration.prototype.setVerificationKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string first_name = 2;
 * @return {string}
 */
proto.usrpb.Registration.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.Registration} returns this
 */
proto.usrpb.Registration.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string middle_name = 3;
 * @return {string}
 */
proto.usrpb.Registration.prototype.getMiddleName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.Registration} returns this
 */
proto.usrpb.Registration.prototype.setMiddleName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string last_name = 4;
 * @return {string}
 */
proto.usrpb.Registration.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.Registration} returns this
 */
proto.usrpb.Registration.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string email = 5;
 * @return {string}
 */
proto.usrpb.Registration.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.Registration} returns this
 */
proto.usrpb.Registration.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string password = 6;
 * @return {string}
 */
proto.usrpb.Registration.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.Registration} returns this
 */
proto.usrpb.Registration.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string security_word = 7;
 * @return {string}
 */
proto.usrpb.Registration.prototype.getSecurityWord = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.Registration} returns this
 */
proto.usrpb.Registration.prototype.setSecurityWord = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string security_word_hint = 8;
 * @return {string}
 */
proto.usrpb.Registration.prototype.getSecurityWordHint = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.Registration} returns this
 */
proto.usrpb.Registration.prototype.setSecurityWordHint = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string promo_code = 9;
 * @return {string}
 */
proto.usrpb.Registration.prototype.getPromoCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.Registration} returns this
 */
proto.usrpb.Registration.prototype.setPromoCode = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string phone_number = 10;
 * @return {string}
 */
proto.usrpb.Registration.prototype.getPhoneNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.Registration} returns this
 */
proto.usrpb.Registration.prototype.setPhoneNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string suffix = 11;
 * @return {string}
 */
proto.usrpb.Registration.prototype.getSuffix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.Registration} returns this
 */
proto.usrpb.Registration.prototype.setSuffix = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usrpb.VerifyRegistrationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.usrpb.VerifyRegistrationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usrpb.VerifyRegistrationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.VerifyRegistrationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    verificationKey: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usrpb.VerifyRegistrationRequest}
 */
proto.usrpb.VerifyRegistrationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usrpb.VerifyRegistrationRequest;
  return proto.usrpb.VerifyRegistrationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usrpb.VerifyRegistrationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usrpb.VerifyRegistrationRequest}
 */
proto.usrpb.VerifyRegistrationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVerificationKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usrpb.VerifyRegistrationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usrpb.VerifyRegistrationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usrpb.VerifyRegistrationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.VerifyRegistrationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVerificationKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string verification_key = 1;
 * @return {string}
 */
proto.usrpb.VerifyRegistrationRequest.prototype.getVerificationKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.VerifyRegistrationRequest} returns this
 */
proto.usrpb.VerifyRegistrationRequest.prototype.setVerificationKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usrpb.VerifyRegistrationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.usrpb.VerifyRegistrationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usrpb.VerifyRegistrationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.VerifyRegistrationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    account: (f = msg.getAccount()) && proto.usrpb.RegistrationAccount.toObject(includeInstance, f),
    accessToken: jspb.Message.getFieldWithDefault(msg, 3, ""),
    refreshToken: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usrpb.VerifyRegistrationResponse}
 */
proto.usrpb.VerifyRegistrationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usrpb.VerifyRegistrationResponse;
  return proto.usrpb.VerifyRegistrationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usrpb.VerifyRegistrationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usrpb.VerifyRegistrationResponse}
 */
proto.usrpb.VerifyRegistrationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new proto.usrpb.RegistrationAccount;
      reader.readMessage(value,proto.usrpb.RegistrationAccount.deserializeBinaryFromReader);
      msg.setAccount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccessToken(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRefreshToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usrpb.VerifyRegistrationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usrpb.VerifyRegistrationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usrpb.VerifyRegistrationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.VerifyRegistrationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.usrpb.RegistrationAccount.serializeBinaryToWriter
    );
  }
  f = message.getAccessToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRefreshToken();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional RegistrationAccount account = 2;
 * @return {?proto.usrpb.RegistrationAccount}
 */
proto.usrpb.VerifyRegistrationResponse.prototype.getAccount = function() {
  return /** @type{?proto.usrpb.RegistrationAccount} */ (
    jspb.Message.getWrapperField(this, proto.usrpb.RegistrationAccount, 2));
};


/**
 * @param {?proto.usrpb.RegistrationAccount|undefined} value
 * @return {!proto.usrpb.VerifyRegistrationResponse} returns this
*/
proto.usrpb.VerifyRegistrationResponse.prototype.setAccount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.usrpb.VerifyRegistrationResponse} returns this
 */
proto.usrpb.VerifyRegistrationResponse.prototype.clearAccount = function() {
  return this.setAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.usrpb.VerifyRegistrationResponse.prototype.hasAccount = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string access_token = 3;
 * @return {string}
 */
proto.usrpb.VerifyRegistrationResponse.prototype.getAccessToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.VerifyRegistrationResponse} returns this
 */
proto.usrpb.VerifyRegistrationResponse.prototype.setAccessToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string refresh_token = 4;
 * @return {string}
 */
proto.usrpb.VerifyRegistrationResponse.prototype.getRefreshToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.VerifyRegistrationResponse} returns this
 */
proto.usrpb.VerifyRegistrationResponse.prototype.setRefreshToken = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usrpb.RegistrationOwner.prototype.toObject = function(opt_includeInstance) {
  return proto.usrpb.RegistrationOwner.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usrpb.RegistrationOwner} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.RegistrationOwner.toObject = function(includeInstance, msg) {
  var f, obj = {
    ownerId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    isOfficer: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    isOwner: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    ownershipPercent: jspb.Message.getFieldWithDefault(msg, 4, ""),
    firstName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    middleName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    phoneId: jspb.Message.getFieldWithDefault(msg, 8, 0),
    phone: jspb.Message.getFieldWithDefault(msg, 9, ""),
    emailId: jspb.Message.getFieldWithDefault(msg, 10, 0),
    email: jspb.Message.getFieldWithDefault(msg, 11, ""),
    secondaryPhoneId: jspb.Message.getFieldWithDefault(msg, 12, 0),
    secondaryPhone: jspb.Message.getFieldWithDefault(msg, 13, ""),
    addressId: jspb.Message.getFieldWithDefault(msg, 14, 0),
    address1: jspb.Message.getFieldWithDefault(msg, 15, ""),
    address2: jspb.Message.getFieldWithDefault(msg, 16, ""),
    city: jspb.Message.getFieldWithDefault(msg, 17, ""),
    state: jspb.Message.getFieldWithDefault(msg, 18, ""),
    country: jspb.Message.getFieldWithDefault(msg, 19, ""),
    zip: jspb.Message.getFieldWithDefault(msg, 20, ""),
    imgProofOfAddress: jspb.Message.getFieldWithDefault(msg, 21, ""),
    identification: (f = msg.getIdentification()) && proto.usrpb.RegistrationIdentification.toObject(includeInstance, f),
    employment: (f = msg.getEmployment()) && proto.usrpb.RegistrationEmployment.toObject(includeInstance, f),
    association: (f = msg.getAssociation()) && proto.usrpb.RegistrationAssociation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usrpb.RegistrationOwner}
 */
proto.usrpb.RegistrationOwner.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usrpb.RegistrationOwner;
  return proto.usrpb.RegistrationOwner.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usrpb.RegistrationOwner} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usrpb.RegistrationOwner}
 */
proto.usrpb.RegistrationOwner.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOwnerId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsOfficer(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsOwner(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnershipPercent(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMiddleName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPhoneId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setEmailId(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSecondaryPhoneId(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondaryPhone(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAddressId(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress1(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress2(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setZip(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setImgProofOfAddress(value);
      break;
    case 22:
      var value = new proto.usrpb.RegistrationIdentification;
      reader.readMessage(value,proto.usrpb.RegistrationIdentification.deserializeBinaryFromReader);
      msg.setIdentification(value);
      break;
    case 23:
      var value = new proto.usrpb.RegistrationEmployment;
      reader.readMessage(value,proto.usrpb.RegistrationEmployment.deserializeBinaryFromReader);
      msg.setEmployment(value);
      break;
    case 24:
      var value = new proto.usrpb.RegistrationAssociation;
      reader.readMessage(value,proto.usrpb.RegistrationAssociation.deserializeBinaryFromReader);
      msg.setAssociation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usrpb.RegistrationOwner.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usrpb.RegistrationOwner.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usrpb.RegistrationOwner} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.RegistrationOwner.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOwnerId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getIsOfficer();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getIsOwner();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getOwnershipPercent();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMiddleName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPhoneId();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getEmailId();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getSecondaryPhoneId();
  if (f !== 0) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = message.getSecondaryPhone();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getAddressId();
  if (f !== 0) {
    writer.writeUint32(
      14,
      f
    );
  }
  f = message.getAddress1();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getAddress2();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getZip();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getImgProofOfAddress();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getIdentification();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      proto.usrpb.RegistrationIdentification.serializeBinaryToWriter
    );
  }
  f = message.getEmployment();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      proto.usrpb.RegistrationEmployment.serializeBinaryToWriter
    );
  }
  f = message.getAssociation();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      proto.usrpb.RegistrationAssociation.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 owner_id = 1;
 * @return {number}
 */
proto.usrpb.RegistrationOwner.prototype.getOwnerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.setOwnerId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool is_officer = 2;
 * @return {boolean}
 */
proto.usrpb.RegistrationOwner.prototype.getIsOfficer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.setIsOfficer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool is_owner = 3;
 * @return {boolean}
 */
proto.usrpb.RegistrationOwner.prototype.getIsOwner = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.setIsOwner = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string ownership_percent = 4;
 * @return {string}
 */
proto.usrpb.RegistrationOwner.prototype.getOwnershipPercent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.setOwnershipPercent = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string first_name = 5;
 * @return {string}
 */
proto.usrpb.RegistrationOwner.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string middle_name = 6;
 * @return {string}
 */
proto.usrpb.RegistrationOwner.prototype.getMiddleName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.setMiddleName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string last_name = 7;
 * @return {string}
 */
proto.usrpb.RegistrationOwner.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional uint32 phone_id = 8;
 * @return {number}
 */
proto.usrpb.RegistrationOwner.prototype.getPhoneId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.setPhoneId = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string phone = 9;
 * @return {string}
 */
proto.usrpb.RegistrationOwner.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional uint32 email_id = 10;
 * @return {number}
 */
proto.usrpb.RegistrationOwner.prototype.getEmailId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.setEmailId = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string email = 11;
 * @return {string}
 */
proto.usrpb.RegistrationOwner.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional uint32 secondary_phone_id = 12;
 * @return {number}
 */
proto.usrpb.RegistrationOwner.prototype.getSecondaryPhoneId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.setSecondaryPhoneId = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional string secondary_phone = 13;
 * @return {string}
 */
proto.usrpb.RegistrationOwner.prototype.getSecondaryPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.setSecondaryPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional uint32 address_id = 14;
 * @return {number}
 */
proto.usrpb.RegistrationOwner.prototype.getAddressId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.setAddressId = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional string address1 = 15;
 * @return {string}
 */
proto.usrpb.RegistrationOwner.prototype.getAddress1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.setAddress1 = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string address2 = 16;
 * @return {string}
 */
proto.usrpb.RegistrationOwner.prototype.getAddress2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.setAddress2 = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string city = 17;
 * @return {string}
 */
proto.usrpb.RegistrationOwner.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string state = 18;
 * @return {string}
 */
proto.usrpb.RegistrationOwner.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string country = 19;
 * @return {string}
 */
proto.usrpb.RegistrationOwner.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string zip = 20;
 * @return {string}
 */
proto.usrpb.RegistrationOwner.prototype.getZip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.setZip = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string img_proof_of_address = 21;
 * @return {string}
 */
proto.usrpb.RegistrationOwner.prototype.getImgProofOfAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.setImgProofOfAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional RegistrationIdentification identification = 22;
 * @return {?proto.usrpb.RegistrationIdentification}
 */
proto.usrpb.RegistrationOwner.prototype.getIdentification = function() {
  return /** @type{?proto.usrpb.RegistrationIdentification} */ (
    jspb.Message.getWrapperField(this, proto.usrpb.RegistrationIdentification, 22));
};


/**
 * @param {?proto.usrpb.RegistrationIdentification|undefined} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
*/
proto.usrpb.RegistrationOwner.prototype.setIdentification = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.clearIdentification = function() {
  return this.setIdentification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.usrpb.RegistrationOwner.prototype.hasIdentification = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional RegistrationEmployment employment = 23;
 * @return {?proto.usrpb.RegistrationEmployment}
 */
proto.usrpb.RegistrationOwner.prototype.getEmployment = function() {
  return /** @type{?proto.usrpb.RegistrationEmployment} */ (
    jspb.Message.getWrapperField(this, proto.usrpb.RegistrationEmployment, 23));
};


/**
 * @param {?proto.usrpb.RegistrationEmployment|undefined} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
*/
proto.usrpb.RegistrationOwner.prototype.setEmployment = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.clearEmployment = function() {
  return this.setEmployment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.usrpb.RegistrationOwner.prototype.hasEmployment = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional RegistrationAssociation association = 24;
 * @return {?proto.usrpb.RegistrationAssociation}
 */
proto.usrpb.RegistrationOwner.prototype.getAssociation = function() {
  return /** @type{?proto.usrpb.RegistrationAssociation} */ (
    jspb.Message.getWrapperField(this, proto.usrpb.RegistrationAssociation, 24));
};


/**
 * @param {?proto.usrpb.RegistrationAssociation|undefined} value
 * @return {!proto.usrpb.RegistrationOwner} returns this
*/
proto.usrpb.RegistrationOwner.prototype.setAssociation = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.usrpb.RegistrationOwner} returns this
 */
proto.usrpb.RegistrationOwner.prototype.clearAssociation = function() {
  return this.setAssociation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.usrpb.RegistrationOwner.prototype.hasAssociation = function() {
  return jspb.Message.getField(this, 24) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usrpb.RegistrationEmployment.prototype.toObject = function(opt_includeInstance) {
  return proto.usrpb.RegistrationEmployment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usrpb.RegistrationEmployment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.RegistrationEmployment.toObject = function(includeInstance, msg) {
  var f, obj = {
    ownerId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    employmentStatus: jspb.Message.getFieldWithDefault(msg, 2, ""),
    employmentName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    previousEmploymentName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    yearsEmployed: jspb.Message.getFieldWithDefault(msg, 5, 0),
    employmentOccupation: jspb.Message.getFieldWithDefault(msg, 6, ""),
    natureOfBusiness: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usrpb.RegistrationEmployment}
 */
proto.usrpb.RegistrationEmployment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usrpb.RegistrationEmployment;
  return proto.usrpb.RegistrationEmployment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usrpb.RegistrationEmployment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usrpb.RegistrationEmployment}
 */
proto.usrpb.RegistrationEmployment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOwnerId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmploymentStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmploymentName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreviousEmploymentName(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setYearsEmployed(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmploymentOccupation(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setNatureOfBusiness(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usrpb.RegistrationEmployment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usrpb.RegistrationEmployment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usrpb.RegistrationEmployment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.RegistrationEmployment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOwnerId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getEmploymentStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmploymentName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPreviousEmploymentName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getYearsEmployed();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getEmploymentOccupation();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getNatureOfBusiness();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional uint32 owner_id = 1;
 * @return {number}
 */
proto.usrpb.RegistrationEmployment.prototype.getOwnerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.RegistrationEmployment} returns this
 */
proto.usrpb.RegistrationEmployment.prototype.setOwnerId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string employment_status = 2;
 * @return {string}
 */
proto.usrpb.RegistrationEmployment.prototype.getEmploymentStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationEmployment} returns this
 */
proto.usrpb.RegistrationEmployment.prototype.setEmploymentStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string employment_name = 3;
 * @return {string}
 */
proto.usrpb.RegistrationEmployment.prototype.getEmploymentName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationEmployment} returns this
 */
proto.usrpb.RegistrationEmployment.prototype.setEmploymentName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string previous_employment_name = 4;
 * @return {string}
 */
proto.usrpb.RegistrationEmployment.prototype.getPreviousEmploymentName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationEmployment} returns this
 */
proto.usrpb.RegistrationEmployment.prototype.setPreviousEmploymentName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 years_employed = 5;
 * @return {number}
 */
proto.usrpb.RegistrationEmployment.prototype.getYearsEmployed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.RegistrationEmployment} returns this
 */
proto.usrpb.RegistrationEmployment.prototype.setYearsEmployed = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string employment_occupation = 6;
 * @return {string}
 */
proto.usrpb.RegistrationEmployment.prototype.getEmploymentOccupation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationEmployment} returns this
 */
proto.usrpb.RegistrationEmployment.prototype.setEmploymentOccupation = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string nature_of_business = 7;
 * @return {string}
 */
proto.usrpb.RegistrationEmployment.prototype.getNatureOfBusiness = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationEmployment} returns this
 */
proto.usrpb.RegistrationEmployment.prototype.setNatureOfBusiness = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.usrpb.RegistrationAssociation.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usrpb.RegistrationAssociation.prototype.toObject = function(opt_includeInstance) {
  return proto.usrpb.RegistrationAssociation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usrpb.RegistrationAssociation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.RegistrationAssociation.toObject = function(includeInstance, msg) {
  var f, obj = {
    ownerId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    ownership: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    stockOwnership: jspb.Message.getFieldWithDefault(msg, 3, ""),
    brokerMember: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    brokerName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    affiliatePerson: jspb.Message.getFieldWithDefault(msg, 6, ""),
    affiliatePersonPosition: jspb.Message.getFieldWithDefault(msg, 7, ""),
    attachedFilesList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usrpb.RegistrationAssociation}
 */
proto.usrpb.RegistrationAssociation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usrpb.RegistrationAssociation;
  return proto.usrpb.RegistrationAssociation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usrpb.RegistrationAssociation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usrpb.RegistrationAssociation}
 */
proto.usrpb.RegistrationAssociation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOwnerId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOwnership(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStockOwnership(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBrokerMember(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrokerName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAffiliatePerson(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAffiliatePersonPosition(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addAttachedFiles(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usrpb.RegistrationAssociation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usrpb.RegistrationAssociation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usrpb.RegistrationAssociation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.RegistrationAssociation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOwnerId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getOwnership();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getStockOwnership();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBrokerMember();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getBrokerName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAffiliatePerson();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAffiliatePersonPosition();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAttachedFilesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
};


/**
 * optional uint32 owner_id = 1;
 * @return {number}
 */
proto.usrpb.RegistrationAssociation.prototype.getOwnerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.RegistrationAssociation} returns this
 */
proto.usrpb.RegistrationAssociation.prototype.setOwnerId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool ownership = 2;
 * @return {boolean}
 */
proto.usrpb.RegistrationAssociation.prototype.getOwnership = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.usrpb.RegistrationAssociation} returns this
 */
proto.usrpb.RegistrationAssociation.prototype.setOwnership = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string stock_ownership = 3;
 * @return {string}
 */
proto.usrpb.RegistrationAssociation.prototype.getStockOwnership = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationAssociation} returns this
 */
proto.usrpb.RegistrationAssociation.prototype.setStockOwnership = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool broker_member = 4;
 * @return {boolean}
 */
proto.usrpb.RegistrationAssociation.prototype.getBrokerMember = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.usrpb.RegistrationAssociation} returns this
 */
proto.usrpb.RegistrationAssociation.prototype.setBrokerMember = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string broker_name = 5;
 * @return {string}
 */
proto.usrpb.RegistrationAssociation.prototype.getBrokerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationAssociation} returns this
 */
proto.usrpb.RegistrationAssociation.prototype.setBrokerName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string affiliate_person = 6;
 * @return {string}
 */
proto.usrpb.RegistrationAssociation.prototype.getAffiliatePerson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationAssociation} returns this
 */
proto.usrpb.RegistrationAssociation.prototype.setAffiliatePerson = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string affiliate_person_position = 7;
 * @return {string}
 */
proto.usrpb.RegistrationAssociation.prototype.getAffiliatePersonPosition = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationAssociation} returns this
 */
proto.usrpb.RegistrationAssociation.prototype.setAffiliatePersonPosition = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated string attached_files = 8;
 * @return {!Array<string>}
 */
proto.usrpb.RegistrationAssociation.prototype.getAttachedFilesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.usrpb.RegistrationAssociation} returns this
 */
proto.usrpb.RegistrationAssociation.prototype.setAttachedFilesList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.usrpb.RegistrationAssociation} returns this
 */
proto.usrpb.RegistrationAssociation.prototype.addAttachedFiles = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.usrpb.RegistrationAssociation} returns this
 */
proto.usrpb.RegistrationAssociation.prototype.clearAttachedFilesList = function() {
  return this.setAttachedFilesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usrpb.RegistrationIdentification.prototype.toObject = function(opt_includeInstance) {
  return proto.usrpb.RegistrationIdentification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usrpb.RegistrationIdentification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.RegistrationIdentification.toObject = function(includeInstance, msg) {
  var f, obj = {
    ownerId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    identificationId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    identificationNo: jspb.Message.getFieldWithDefault(msg, 3, ""),
    identificationType: jspb.Message.getFieldWithDefault(msg, 4, ""),
    issueDate: (f = msg.getIssueDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    expirationDate: (f = msg.getExpirationDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    dateOfBirth: (f = msg.getDateOfBirth()) && google_type_date_pb.Date.toObject(includeInstance, f),
    countryOfIssuance: jspb.Message.getFieldWithDefault(msg, 8, ""),
    imgGovernmentId: jspb.Message.getFieldWithDefault(msg, 10, ""),
    kycStatus: jspb.Message.getFieldWithDefault(msg, 11, ""),
    statusReason: jspb.Message.getFieldWithDefault(msg, 12, ""),
    taxIdentificationId: jspb.Message.getFieldWithDefault(msg, 13, 0),
    taxState: jspb.Message.getFieldWithDefault(msg, 14, ""),
    taxNo: jspb.Message.getFieldWithDefault(msg, 15, ""),
    taxCountry: jspb.Message.getFieldWithDefault(msg, 16, ""),
    citizenship: jspb.Message.getFieldWithDefault(msg, 17, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usrpb.RegistrationIdentification}
 */
proto.usrpb.RegistrationIdentification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usrpb.RegistrationIdentification;
  return proto.usrpb.RegistrationIdentification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usrpb.RegistrationIdentification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usrpb.RegistrationIdentification}
 */
proto.usrpb.RegistrationIdentification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOwnerId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setIdentificationId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentificationNo(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentificationType(value);
      break;
    case 5:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setIssueDate(value);
      break;
    case 6:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setExpirationDate(value);
      break;
    case 7:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setDateOfBirth(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryOfIssuance(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setImgGovernmentId(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setKycStatus(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusReason(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTaxIdentificationId(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaxState(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaxNo(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaxCountry(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setCitizenship(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usrpb.RegistrationIdentification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usrpb.RegistrationIdentification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usrpb.RegistrationIdentification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.RegistrationIdentification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOwnerId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getIdentificationId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getIdentificationNo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIdentificationType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIssueDate();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getExpirationDate();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getDateOfBirth();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getCountryOfIssuance();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getImgGovernmentId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getKycStatus();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getStatusReason();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getTaxIdentificationId();
  if (f !== 0) {
    writer.writeUint32(
      13,
      f
    );
  }
  f = message.getTaxState();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getTaxNo();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getTaxCountry();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getCitizenship();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
};


/**
 * optional uint32 owner_id = 1;
 * @return {number}
 */
proto.usrpb.RegistrationIdentification.prototype.getOwnerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.RegistrationIdentification} returns this
 */
proto.usrpb.RegistrationIdentification.prototype.setOwnerId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 identification_id = 2;
 * @return {number}
 */
proto.usrpb.RegistrationIdentification.prototype.getIdentificationId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.RegistrationIdentification} returns this
 */
proto.usrpb.RegistrationIdentification.prototype.setIdentificationId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string identification_no = 3;
 * @return {string}
 */
proto.usrpb.RegistrationIdentification.prototype.getIdentificationNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationIdentification} returns this
 */
proto.usrpb.RegistrationIdentification.prototype.setIdentificationNo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string identification_type = 4;
 * @return {string}
 */
proto.usrpb.RegistrationIdentification.prototype.getIdentificationType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationIdentification} returns this
 */
proto.usrpb.RegistrationIdentification.prototype.setIdentificationType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.type.Date issue_date = 5;
 * @return {?proto.google.type.Date}
 */
proto.usrpb.RegistrationIdentification.prototype.getIssueDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 5));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.usrpb.RegistrationIdentification} returns this
*/
proto.usrpb.RegistrationIdentification.prototype.setIssueDate = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.usrpb.RegistrationIdentification} returns this
 */
proto.usrpb.RegistrationIdentification.prototype.clearIssueDate = function() {
  return this.setIssueDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.usrpb.RegistrationIdentification.prototype.hasIssueDate = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.type.Date expiration_date = 6;
 * @return {?proto.google.type.Date}
 */
proto.usrpb.RegistrationIdentification.prototype.getExpirationDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 6));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.usrpb.RegistrationIdentification} returns this
*/
proto.usrpb.RegistrationIdentification.prototype.setExpirationDate = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.usrpb.RegistrationIdentification} returns this
 */
proto.usrpb.RegistrationIdentification.prototype.clearExpirationDate = function() {
  return this.setExpirationDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.usrpb.RegistrationIdentification.prototype.hasExpirationDate = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.type.Date date_of_birth = 7;
 * @return {?proto.google.type.Date}
 */
proto.usrpb.RegistrationIdentification.prototype.getDateOfBirth = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 7));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.usrpb.RegistrationIdentification} returns this
*/
proto.usrpb.RegistrationIdentification.prototype.setDateOfBirth = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.usrpb.RegistrationIdentification} returns this
 */
proto.usrpb.RegistrationIdentification.prototype.clearDateOfBirth = function() {
  return this.setDateOfBirth(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.usrpb.RegistrationIdentification.prototype.hasDateOfBirth = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string country_of_issuance = 8;
 * @return {string}
 */
proto.usrpb.RegistrationIdentification.prototype.getCountryOfIssuance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationIdentification} returns this
 */
proto.usrpb.RegistrationIdentification.prototype.setCountryOfIssuance = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string img_government_id = 10;
 * @return {string}
 */
proto.usrpb.RegistrationIdentification.prototype.getImgGovernmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationIdentification} returns this
 */
proto.usrpb.RegistrationIdentification.prototype.setImgGovernmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string kyc_status = 11;
 * @return {string}
 */
proto.usrpb.RegistrationIdentification.prototype.getKycStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationIdentification} returns this
 */
proto.usrpb.RegistrationIdentification.prototype.setKycStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string status_reason = 12;
 * @return {string}
 */
proto.usrpb.RegistrationIdentification.prototype.getStatusReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationIdentification} returns this
 */
proto.usrpb.RegistrationIdentification.prototype.setStatusReason = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional uint32 tax_identification_id = 13;
 * @return {number}
 */
proto.usrpb.RegistrationIdentification.prototype.getTaxIdentificationId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.RegistrationIdentification} returns this
 */
proto.usrpb.RegistrationIdentification.prototype.setTaxIdentificationId = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string tax_state = 14;
 * @return {string}
 */
proto.usrpb.RegistrationIdentification.prototype.getTaxState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationIdentification} returns this
 */
proto.usrpb.RegistrationIdentification.prototype.setTaxState = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string tax_no = 15;
 * @return {string}
 */
proto.usrpb.RegistrationIdentification.prototype.getTaxNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationIdentification} returns this
 */
proto.usrpb.RegistrationIdentification.prototype.setTaxNo = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string tax_country = 16;
 * @return {string}
 */
proto.usrpb.RegistrationIdentification.prototype.getTaxCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationIdentification} returns this
 */
proto.usrpb.RegistrationIdentification.prototype.setTaxCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string citizenship = 17;
 * @return {string}
 */
proto.usrpb.RegistrationIdentification.prototype.getCitizenship = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationIdentification} returns this
 */
proto.usrpb.RegistrationIdentification.prototype.setCitizenship = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usrpb.RegistrationObjective.prototype.toObject = function(opt_includeInstance) {
  return proto.usrpb.RegistrationObjective.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usrpb.RegistrationObjective} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.RegistrationObjective.toObject = function(includeInstance, msg) {
  var f, obj = {
    investmentObjectiveCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    annualIncome: jspb.Message.getFieldWithDefault(msg, 2, ""),
    liquidNetWorth: jspb.Message.getFieldWithDefault(msg, 3, ""),
    sourceOfFunds: jspb.Message.getFieldWithDefault(msg, 4, ""),
    sourceOfFundsDescription: jspb.Message.getFieldWithDefault(msg, 5, ""),
    riskTolerance: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usrpb.RegistrationObjective}
 */
proto.usrpb.RegistrationObjective.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usrpb.RegistrationObjective;
  return proto.usrpb.RegistrationObjective.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usrpb.RegistrationObjective} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usrpb.RegistrationObjective}
 */
proto.usrpb.RegistrationObjective.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvestmentObjectiveCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnnualIncome(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLiquidNetWorth(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceOfFunds(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceOfFundsDescription(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRiskTolerance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usrpb.RegistrationObjective.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usrpb.RegistrationObjective.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usrpb.RegistrationObjective} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.RegistrationObjective.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInvestmentObjectiveCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAnnualIncome();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLiquidNetWorth();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSourceOfFunds();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSourceOfFundsDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRiskTolerance();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string investment_objective_code = 1;
 * @return {string}
 */
proto.usrpb.RegistrationObjective.prototype.getInvestmentObjectiveCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationObjective} returns this
 */
proto.usrpb.RegistrationObjective.prototype.setInvestmentObjectiveCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string annual_income = 2;
 * @return {string}
 */
proto.usrpb.RegistrationObjective.prototype.getAnnualIncome = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationObjective} returns this
 */
proto.usrpb.RegistrationObjective.prototype.setAnnualIncome = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string liquid_net_worth = 3;
 * @return {string}
 */
proto.usrpb.RegistrationObjective.prototype.getLiquidNetWorth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationObjective} returns this
 */
proto.usrpb.RegistrationObjective.prototype.setLiquidNetWorth = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string source_of_funds = 4;
 * @return {string}
 */
proto.usrpb.RegistrationObjective.prototype.getSourceOfFunds = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationObjective} returns this
 */
proto.usrpb.RegistrationObjective.prototype.setSourceOfFunds = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string source_of_funds_description = 5;
 * @return {string}
 */
proto.usrpb.RegistrationObjective.prototype.getSourceOfFundsDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationObjective} returns this
 */
proto.usrpb.RegistrationObjective.prototype.setSourceOfFundsDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string risk_tolerance = 6;
 * @return {string}
 */
proto.usrpb.RegistrationObjective.prototype.getRiskTolerance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationObjective} returns this
 */
proto.usrpb.RegistrationObjective.prototype.setRiskTolerance = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usrpb.RegistrationTrustedContact.prototype.toObject = function(opt_includeInstance) {
  return proto.usrpb.RegistrationTrustedContact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usrpb.RegistrationTrustedContact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.RegistrationTrustedContact.toObject = function(includeInstance, msg) {
  var f, obj = {
    ownerId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    firstName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    middleName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    dateOfBirth: (f = msg.getDateOfBirth()) && google_type_date_pb.Date.toObject(includeInstance, f),
    relationship: jspb.Message.getFieldWithDefault(msg, 6, ""),
    emailId: jspb.Message.getFieldWithDefault(msg, 7, 0),
    emailType: jspb.Message.getFieldWithDefault(msg, 8, ""),
    email: jspb.Message.getFieldWithDefault(msg, 9, ""),
    phoneId: jspb.Message.getFieldWithDefault(msg, 10, 0),
    phoneType: jspb.Message.getFieldWithDefault(msg, 11, ""),
    phone: jspb.Message.getFieldWithDefault(msg, 12, ""),
    identificationId: jspb.Message.getFieldWithDefault(msg, 13, 0),
    identificationType: jspb.Message.getFieldWithDefault(msg, 14, ""),
    identificationValue: jspb.Message.getFieldWithDefault(msg, 15, ""),
    addressId: jspb.Message.getFieldWithDefault(msg, 18, 0),
    addressType: jspb.Message.getFieldWithDefault(msg, 19, ""),
    address1: jspb.Message.getFieldWithDefault(msg, 20, ""),
    address2: jspb.Message.getFieldWithDefault(msg, 21, ""),
    city: jspb.Message.getFieldWithDefault(msg, 22, ""),
    addressState: jspb.Message.getFieldWithDefault(msg, 23, ""),
    zip: jspb.Message.getFieldWithDefault(msg, 24, ""),
    country: jspb.Message.getFieldWithDefault(msg, 25, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usrpb.RegistrationTrustedContact}
 */
proto.usrpb.RegistrationTrustedContact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usrpb.RegistrationTrustedContact;
  return proto.usrpb.RegistrationTrustedContact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usrpb.RegistrationTrustedContact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usrpb.RegistrationTrustedContact}
 */
proto.usrpb.RegistrationTrustedContact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOwnerId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMiddleName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 5:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setDateOfBirth(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRelationship(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setEmailId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailType(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPhoneId(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneType(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setIdentificationId(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentificationType(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentificationValue(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAddressId(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressType(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress1(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress2(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressState(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setZip(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usrpb.RegistrationTrustedContact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usrpb.RegistrationTrustedContact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usrpb.RegistrationTrustedContact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.RegistrationTrustedContact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOwnerId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMiddleName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDateOfBirth();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getRelationship();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getEmailId();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getEmailType();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPhoneId();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
  f = message.getPhoneType();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getIdentificationId();
  if (f !== 0) {
    writer.writeUint32(
      13,
      f
    );
  }
  f = message.getIdentificationType();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getIdentificationValue();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getAddressId();
  if (f !== 0) {
    writer.writeUint32(
      18,
      f
    );
  }
  f = message.getAddressType();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getAddress1();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getAddress2();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getAddressState();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getZip();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
};


/**
 * optional uint32 owner_id = 1;
 * @return {number}
 */
proto.usrpb.RegistrationTrustedContact.prototype.getOwnerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
 */
proto.usrpb.RegistrationTrustedContact.prototype.setOwnerId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string first_name = 2;
 * @return {string}
 */
proto.usrpb.RegistrationTrustedContact.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
 */
proto.usrpb.RegistrationTrustedContact.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string middle_name = 3;
 * @return {string}
 */
proto.usrpb.RegistrationTrustedContact.prototype.getMiddleName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
 */
proto.usrpb.RegistrationTrustedContact.prototype.setMiddleName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string last_name = 4;
 * @return {string}
 */
proto.usrpb.RegistrationTrustedContact.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
 */
proto.usrpb.RegistrationTrustedContact.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.type.Date date_of_birth = 5;
 * @return {?proto.google.type.Date}
 */
proto.usrpb.RegistrationTrustedContact.prototype.getDateOfBirth = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 5));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
*/
proto.usrpb.RegistrationTrustedContact.prototype.setDateOfBirth = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
 */
proto.usrpb.RegistrationTrustedContact.prototype.clearDateOfBirth = function() {
  return this.setDateOfBirth(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.usrpb.RegistrationTrustedContact.prototype.hasDateOfBirth = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string relationship = 6;
 * @return {string}
 */
proto.usrpb.RegistrationTrustedContact.prototype.getRelationship = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
 */
proto.usrpb.RegistrationTrustedContact.prototype.setRelationship = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional uint32 email_id = 7;
 * @return {number}
 */
proto.usrpb.RegistrationTrustedContact.prototype.getEmailId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
 */
proto.usrpb.RegistrationTrustedContact.prototype.setEmailId = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string email_type = 8;
 * @return {string}
 */
proto.usrpb.RegistrationTrustedContact.prototype.getEmailType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
 */
proto.usrpb.RegistrationTrustedContact.prototype.setEmailType = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string email = 9;
 * @return {string}
 */
proto.usrpb.RegistrationTrustedContact.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
 */
proto.usrpb.RegistrationTrustedContact.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional uint32 phone_id = 10;
 * @return {number}
 */
proto.usrpb.RegistrationTrustedContact.prototype.getPhoneId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
 */
proto.usrpb.RegistrationTrustedContact.prototype.setPhoneId = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string phone_type = 11;
 * @return {string}
 */
proto.usrpb.RegistrationTrustedContact.prototype.getPhoneType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
 */
proto.usrpb.RegistrationTrustedContact.prototype.setPhoneType = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string phone = 12;
 * @return {string}
 */
proto.usrpb.RegistrationTrustedContact.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
 */
proto.usrpb.RegistrationTrustedContact.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional uint32 identification_id = 13;
 * @return {number}
 */
proto.usrpb.RegistrationTrustedContact.prototype.getIdentificationId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
 */
proto.usrpb.RegistrationTrustedContact.prototype.setIdentificationId = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string identification_type = 14;
 * @return {string}
 */
proto.usrpb.RegistrationTrustedContact.prototype.getIdentificationType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
 */
proto.usrpb.RegistrationTrustedContact.prototype.setIdentificationType = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string identification_value = 15;
 * @return {string}
 */
proto.usrpb.RegistrationTrustedContact.prototype.getIdentificationValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
 */
proto.usrpb.RegistrationTrustedContact.prototype.setIdentificationValue = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional uint32 address_id = 18;
 * @return {number}
 */
proto.usrpb.RegistrationTrustedContact.prototype.getAddressId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
 */
proto.usrpb.RegistrationTrustedContact.prototype.setAddressId = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional string address_type = 19;
 * @return {string}
 */
proto.usrpb.RegistrationTrustedContact.prototype.getAddressType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
 */
proto.usrpb.RegistrationTrustedContact.prototype.setAddressType = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string address1 = 20;
 * @return {string}
 */
proto.usrpb.RegistrationTrustedContact.prototype.getAddress1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
 */
proto.usrpb.RegistrationTrustedContact.prototype.setAddress1 = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string address2 = 21;
 * @return {string}
 */
proto.usrpb.RegistrationTrustedContact.prototype.getAddress2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
 */
proto.usrpb.RegistrationTrustedContact.prototype.setAddress2 = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string city = 22;
 * @return {string}
 */
proto.usrpb.RegistrationTrustedContact.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
 */
proto.usrpb.RegistrationTrustedContact.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string address_state = 23;
 * @return {string}
 */
proto.usrpb.RegistrationTrustedContact.prototype.getAddressState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
 */
proto.usrpb.RegistrationTrustedContact.prototype.setAddressState = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string zip = 24;
 * @return {string}
 */
proto.usrpb.RegistrationTrustedContact.prototype.getZip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
 */
proto.usrpb.RegistrationTrustedContact.prototype.setZip = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string country = 25;
 * @return {string}
 */
proto.usrpb.RegistrationTrustedContact.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationTrustedContact} returns this
 */
proto.usrpb.RegistrationTrustedContact.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usrpb.RegistrationCorpPrimaryAgentAddress.prototype.toObject = function(opt_includeInstance) {
  return proto.usrpb.RegistrationCorpPrimaryAgentAddress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usrpb.RegistrationCorpPrimaryAgentAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.RegistrationCorpPrimaryAgentAddress.toObject = function(includeInstance, msg) {
  var f, obj = {
    addressId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    address1: jspb.Message.getFieldWithDefault(msg, 2, ""),
    address2: jspb.Message.getFieldWithDefault(msg, 3, ""),
    city: jspb.Message.getFieldWithDefault(msg, 4, ""),
    state: jspb.Message.getFieldWithDefault(msg, 5, ""),
    zip: jspb.Message.getFieldWithDefault(msg, 6, ""),
    country: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usrpb.RegistrationCorpPrimaryAgentAddress}
 */
proto.usrpb.RegistrationCorpPrimaryAgentAddress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usrpb.RegistrationCorpPrimaryAgentAddress;
  return proto.usrpb.RegistrationCorpPrimaryAgentAddress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usrpb.RegistrationCorpPrimaryAgentAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usrpb.RegistrationCorpPrimaryAgentAddress}
 */
proto.usrpb.RegistrationCorpPrimaryAgentAddress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAddressId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress1(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress2(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setZip(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usrpb.RegistrationCorpPrimaryAgentAddress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usrpb.RegistrationCorpPrimaryAgentAddress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usrpb.RegistrationCorpPrimaryAgentAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.RegistrationCorpPrimaryAgentAddress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddressId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getAddress1();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddress2();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getZip();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional uint32 address_id = 1;
 * @return {number}
 */
proto.usrpb.RegistrationCorpPrimaryAgentAddress.prototype.getAddressId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.RegistrationCorpPrimaryAgentAddress} returns this
 */
proto.usrpb.RegistrationCorpPrimaryAgentAddress.prototype.setAddressId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string address1 = 2;
 * @return {string}
 */
proto.usrpb.RegistrationCorpPrimaryAgentAddress.prototype.getAddress1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationCorpPrimaryAgentAddress} returns this
 */
proto.usrpb.RegistrationCorpPrimaryAgentAddress.prototype.setAddress1 = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string address2 = 3;
 * @return {string}
 */
proto.usrpb.RegistrationCorpPrimaryAgentAddress.prototype.getAddress2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationCorpPrimaryAgentAddress} returns this
 */
proto.usrpb.RegistrationCorpPrimaryAgentAddress.prototype.setAddress2 = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string city = 4;
 * @return {string}
 */
proto.usrpb.RegistrationCorpPrimaryAgentAddress.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationCorpPrimaryAgentAddress} returns this
 */
proto.usrpb.RegistrationCorpPrimaryAgentAddress.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string state = 5;
 * @return {string}
 */
proto.usrpb.RegistrationCorpPrimaryAgentAddress.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationCorpPrimaryAgentAddress} returns this
 */
proto.usrpb.RegistrationCorpPrimaryAgentAddress.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string zip = 6;
 * @return {string}
 */
proto.usrpb.RegistrationCorpPrimaryAgentAddress.prototype.getZip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationCorpPrimaryAgentAddress} returns this
 */
proto.usrpb.RegistrationCorpPrimaryAgentAddress.prototype.setZip = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string country = 7;
 * @return {string}
 */
proto.usrpb.RegistrationCorpPrimaryAgentAddress.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationCorpPrimaryAgentAddress} returns this
 */
proto.usrpb.RegistrationCorpPrimaryAgentAddress.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.usrpb.RegistrationAccount.repeatedFields_ = [22];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usrpb.RegistrationAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.usrpb.RegistrationAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usrpb.RegistrationAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.RegistrationAccount.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    correspondent: jspb.Message.getFieldWithDefault(msg, 2, ""),
    accountNo: jspb.Message.getFieldWithDefault(msg, 3, ""),
    accountType: jspb.Message.getFieldWithDefault(msg, 4, ""),
    subType: jspb.Message.getFieldWithDefault(msg, 5, ""),
    accountName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    formationCountry: jspb.Message.getFieldWithDefault(msg, 7, ""),
    onboardingPercent: jspb.Message.getFieldWithDefault(msg, 8, ""),
    tinId: jspb.Message.getFieldWithDefault(msg, 9, 0),
    tin: jspb.Message.getFieldWithDefault(msg, 10, ""),
    customerAccountAgreement: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    marginAgreement: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    marginDisclosure: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    marginType: jspb.Message.getFieldWithDefault(msg, 14, ""),
    stocks: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    option: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
    privacyConsent: jspb.Message.getFieldWithDefault(msg, 17, ""),
    accreditedInvestor: jspb.Message.getBooleanFieldWithDefault(msg, 18, false),
    primaryOwner: (f = msg.getPrimaryOwner()) && proto.usrpb.RegistrationOwner.toObject(includeInstance, f),
    jointOwner: (f = msg.getJointOwner()) && proto.usrpb.RegistrationOwner.toObject(includeInstance, f),
    trustedContact: (f = msg.getTrustedContact()) && proto.usrpb.RegistrationTrustedContact.toObject(includeInstance, f),
    corpOwnersList: jspb.Message.toObjectList(msg.getCorpOwnersList(),
    proto.usrpb.RegistrationOwner.toObject, includeInstance),
    corpPrimaryAgentAddress: (f = msg.getCorpPrimaryAgentAddress()) && proto.usrpb.RegistrationCorpPrimaryAgentAddress.toObject(includeInstance, f),
    objective: (f = msg.getObjective()) && proto.usrpb.RegistrationObjective.toObject(includeInstance, f),
    imgSignature: jspb.Message.getFieldWithDefault(msg, 25, ""),
    status: jspb.Message.getFieldWithDefault(msg, 26, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 27, 0),
    rep: jspb.Message.getFieldWithDefault(msg, 28, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usrpb.RegistrationAccount}
 */
proto.usrpb.RegistrationAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usrpb.RegistrationAccount;
  return proto.usrpb.RegistrationAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usrpb.RegistrationAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usrpb.RegistrationAccount}
 */
proto.usrpb.RegistrationAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNo(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setFormationCountry(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setOnboardingPercent(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTinId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setTin(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCustomerAccountAgreement(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMarginAgreement(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMarginDisclosure(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarginType(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStocks(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOption(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrivacyConsent(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAccreditedInvestor(value);
      break;
    case 19:
      var value = new proto.usrpb.RegistrationOwner;
      reader.readMessage(value,proto.usrpb.RegistrationOwner.deserializeBinaryFromReader);
      msg.setPrimaryOwner(value);
      break;
    case 20:
      var value = new proto.usrpb.RegistrationOwner;
      reader.readMessage(value,proto.usrpb.RegistrationOwner.deserializeBinaryFromReader);
      msg.setJointOwner(value);
      break;
    case 21:
      var value = new proto.usrpb.RegistrationTrustedContact;
      reader.readMessage(value,proto.usrpb.RegistrationTrustedContact.deserializeBinaryFromReader);
      msg.setTrustedContact(value);
      break;
    case 22:
      var value = new proto.usrpb.RegistrationOwner;
      reader.readMessage(value,proto.usrpb.RegistrationOwner.deserializeBinaryFromReader);
      msg.addCorpOwners(value);
      break;
    case 23:
      var value = new proto.usrpb.RegistrationCorpPrimaryAgentAddress;
      reader.readMessage(value,proto.usrpb.RegistrationCorpPrimaryAgentAddress.deserializeBinaryFromReader);
      msg.setCorpPrimaryAgentAddress(value);
      break;
    case 24:
      var value = new proto.usrpb.RegistrationObjective;
      reader.readMessage(value,proto.usrpb.RegistrationObjective.deserializeBinaryFromReader);
      msg.setObjective(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setImgSignature(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUserId(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setRep(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usrpb.RegistrationAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usrpb.RegistrationAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usrpb.RegistrationAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.RegistrationAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAccountType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSubType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAccountName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFormationCountry();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getOnboardingPercent();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getTinId();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getTin();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCustomerAccountAgreement();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getMarginAgreement();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getMarginDisclosure();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getMarginType();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getStocks();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getOption();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getPrivacyConsent();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getAccreditedInvestor();
  if (f) {
    writer.writeBool(
      18,
      f
    );
  }
  f = message.getPrimaryOwner();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      proto.usrpb.RegistrationOwner.serializeBinaryToWriter
    );
  }
  f = message.getJointOwner();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      proto.usrpb.RegistrationOwner.serializeBinaryToWriter
    );
  }
  f = message.getTrustedContact();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.usrpb.RegistrationTrustedContact.serializeBinaryToWriter
    );
  }
  f = message.getCorpOwnersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      22,
      f,
      proto.usrpb.RegistrationOwner.serializeBinaryToWriter
    );
  }
  f = message.getCorpPrimaryAgentAddress();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      proto.usrpb.RegistrationCorpPrimaryAgentAddress.serializeBinaryToWriter
    );
  }
  f = message.getObjective();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      proto.usrpb.RegistrationObjective.serializeBinaryToWriter
    );
  }
  f = message.getImgSignature();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint32(
      27,
      f
    );
  }
  f = message.getRep();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
};


/**
 * optional uint32 account_id = 1;
 * @return {number}
 */
proto.usrpb.RegistrationAccount.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string correspondent = 2;
 * @return {string}
 */
proto.usrpb.RegistrationAccount.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string account_no = 3;
 * @return {string}
 */
proto.usrpb.RegistrationAccount.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string account_type = 4;
 * @return {string}
 */
proto.usrpb.RegistrationAccount.prototype.getAccountType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.setAccountType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string sub_type = 5;
 * @return {string}
 */
proto.usrpb.RegistrationAccount.prototype.getSubType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.setSubType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string account_name = 6;
 * @return {string}
 */
proto.usrpb.RegistrationAccount.prototype.getAccountName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.setAccountName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string formation_country = 7;
 * @return {string}
 */
proto.usrpb.RegistrationAccount.prototype.getFormationCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.setFormationCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string onboarding_percent = 8;
 * @return {string}
 */
proto.usrpb.RegistrationAccount.prototype.getOnboardingPercent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.setOnboardingPercent = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional uint32 tin_id = 9;
 * @return {number}
 */
proto.usrpb.RegistrationAccount.prototype.getTinId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.setTinId = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string tin = 10;
 * @return {string}
 */
proto.usrpb.RegistrationAccount.prototype.getTin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.setTin = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional bool customer_account_agreement = 11;
 * @return {boolean}
 */
proto.usrpb.RegistrationAccount.prototype.getCustomerAccountAgreement = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.setCustomerAccountAgreement = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool margin_agreement = 12;
 * @return {boolean}
 */
proto.usrpb.RegistrationAccount.prototype.getMarginAgreement = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.setMarginAgreement = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool margin_disclosure = 13;
 * @return {boolean}
 */
proto.usrpb.RegistrationAccount.prototype.getMarginDisclosure = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.setMarginDisclosure = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional string margin_type = 14;
 * @return {string}
 */
proto.usrpb.RegistrationAccount.prototype.getMarginType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.setMarginType = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional bool stocks = 15;
 * @return {boolean}
 */
proto.usrpb.RegistrationAccount.prototype.getStocks = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.setStocks = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional bool option = 16;
 * @return {boolean}
 */
proto.usrpb.RegistrationAccount.prototype.getOption = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.setOption = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional string privacy_consent = 17;
 * @return {string}
 */
proto.usrpb.RegistrationAccount.prototype.getPrivacyConsent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.setPrivacyConsent = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional bool accredited_investor = 18;
 * @return {boolean}
 */
proto.usrpb.RegistrationAccount.prototype.getAccreditedInvestor = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.setAccreditedInvestor = function(value) {
  return jspb.Message.setProto3BooleanField(this, 18, value);
};


/**
 * optional RegistrationOwner primary_owner = 19;
 * @return {?proto.usrpb.RegistrationOwner}
 */
proto.usrpb.RegistrationAccount.prototype.getPrimaryOwner = function() {
  return /** @type{?proto.usrpb.RegistrationOwner} */ (
    jspb.Message.getWrapperField(this, proto.usrpb.RegistrationOwner, 19));
};


/**
 * @param {?proto.usrpb.RegistrationOwner|undefined} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
*/
proto.usrpb.RegistrationAccount.prototype.setPrimaryOwner = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.clearPrimaryOwner = function() {
  return this.setPrimaryOwner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.usrpb.RegistrationAccount.prototype.hasPrimaryOwner = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional RegistrationOwner joint_owner = 20;
 * @return {?proto.usrpb.RegistrationOwner}
 */
proto.usrpb.RegistrationAccount.prototype.getJointOwner = function() {
  return /** @type{?proto.usrpb.RegistrationOwner} */ (
    jspb.Message.getWrapperField(this, proto.usrpb.RegistrationOwner, 20));
};


/**
 * @param {?proto.usrpb.RegistrationOwner|undefined} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
*/
proto.usrpb.RegistrationAccount.prototype.setJointOwner = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.clearJointOwner = function() {
  return this.setJointOwner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.usrpb.RegistrationAccount.prototype.hasJointOwner = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional RegistrationTrustedContact trusted_contact = 21;
 * @return {?proto.usrpb.RegistrationTrustedContact}
 */
proto.usrpb.RegistrationAccount.prototype.getTrustedContact = function() {
  return /** @type{?proto.usrpb.RegistrationTrustedContact} */ (
    jspb.Message.getWrapperField(this, proto.usrpb.RegistrationTrustedContact, 21));
};


/**
 * @param {?proto.usrpb.RegistrationTrustedContact|undefined} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
*/
proto.usrpb.RegistrationAccount.prototype.setTrustedContact = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.clearTrustedContact = function() {
  return this.setTrustedContact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.usrpb.RegistrationAccount.prototype.hasTrustedContact = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * repeated RegistrationOwner corp_owners = 22;
 * @return {!Array<!proto.usrpb.RegistrationOwner>}
 */
proto.usrpb.RegistrationAccount.prototype.getCorpOwnersList = function() {
  return /** @type{!Array<!proto.usrpb.RegistrationOwner>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.usrpb.RegistrationOwner, 22));
};


/**
 * @param {!Array<!proto.usrpb.RegistrationOwner>} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
*/
proto.usrpb.RegistrationAccount.prototype.setCorpOwnersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 22, value);
};


/**
 * @param {!proto.usrpb.RegistrationOwner=} opt_value
 * @param {number=} opt_index
 * @return {!proto.usrpb.RegistrationOwner}
 */
proto.usrpb.RegistrationAccount.prototype.addCorpOwners = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 22, opt_value, proto.usrpb.RegistrationOwner, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.clearCorpOwnersList = function() {
  return this.setCorpOwnersList([]);
};


/**
 * optional RegistrationCorpPrimaryAgentAddress corp_primary_agent_address = 23;
 * @return {?proto.usrpb.RegistrationCorpPrimaryAgentAddress}
 */
proto.usrpb.RegistrationAccount.prototype.getCorpPrimaryAgentAddress = function() {
  return /** @type{?proto.usrpb.RegistrationCorpPrimaryAgentAddress} */ (
    jspb.Message.getWrapperField(this, proto.usrpb.RegistrationCorpPrimaryAgentAddress, 23));
};


/**
 * @param {?proto.usrpb.RegistrationCorpPrimaryAgentAddress|undefined} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
*/
proto.usrpb.RegistrationAccount.prototype.setCorpPrimaryAgentAddress = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.clearCorpPrimaryAgentAddress = function() {
  return this.setCorpPrimaryAgentAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.usrpb.RegistrationAccount.prototype.hasCorpPrimaryAgentAddress = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional RegistrationObjective objective = 24;
 * @return {?proto.usrpb.RegistrationObjective}
 */
proto.usrpb.RegistrationAccount.prototype.getObjective = function() {
  return /** @type{?proto.usrpb.RegistrationObjective} */ (
    jspb.Message.getWrapperField(this, proto.usrpb.RegistrationObjective, 24));
};


/**
 * @param {?proto.usrpb.RegistrationObjective|undefined} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
*/
proto.usrpb.RegistrationAccount.prototype.setObjective = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.clearObjective = function() {
  return this.setObjective(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.usrpb.RegistrationAccount.prototype.hasObjective = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional string img_signature = 25;
 * @return {string}
 */
proto.usrpb.RegistrationAccount.prototype.getImgSignature = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.setImgSignature = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string status = 26;
 * @return {string}
 */
proto.usrpb.RegistrationAccount.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional uint32 user_id = 27;
 * @return {number}
 */
proto.usrpb.RegistrationAccount.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 27, value);
};


/**
 * optional string rep = 28;
 * @return {string}
 */
proto.usrpb.RegistrationAccount.prototype.getRep = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.RegistrationAccount} returns this
 */
proto.usrpb.RegistrationAccount.prototype.setRep = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usrpb.SaveOnboardingPercentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.usrpb.SaveOnboardingPercentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usrpb.SaveOnboardingPercentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.SaveOnboardingPercentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    onboardingPercent: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usrpb.SaveOnboardingPercentRequest}
 */
proto.usrpb.SaveOnboardingPercentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usrpb.SaveOnboardingPercentRequest;
  return proto.usrpb.SaveOnboardingPercentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usrpb.SaveOnboardingPercentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usrpb.SaveOnboardingPercentRequest}
 */
proto.usrpb.SaveOnboardingPercentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOnboardingPercent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usrpb.SaveOnboardingPercentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usrpb.SaveOnboardingPercentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usrpb.SaveOnboardingPercentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.SaveOnboardingPercentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOnboardingPercent();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 onboarding_percent = 1;
 * @return {number}
 */
proto.usrpb.SaveOnboardingPercentRequest.prototype.getOnboardingPercent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.SaveOnboardingPercentRequest} returns this
 */
proto.usrpb.SaveOnboardingPercentRequest.prototype.setOnboardingPercent = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.usrpb.SaveRegistrationIdentificationRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usrpb.SaveRegistrationIdentificationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.usrpb.SaveRegistrationIdentificationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usrpb.SaveRegistrationIdentificationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.SaveRegistrationIdentificationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    primaryOwner: (f = msg.getPrimaryOwner()) && proto.usrpb.RegistrationIdentification.toObject(includeInstance, f),
    corpOwnersList: jspb.Message.toObjectList(msg.getCorpOwnersList(),
    proto.usrpb.RegistrationIdentification.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usrpb.SaveRegistrationIdentificationRequest}
 */
proto.usrpb.SaveRegistrationIdentificationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usrpb.SaveRegistrationIdentificationRequest;
  return proto.usrpb.SaveRegistrationIdentificationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usrpb.SaveRegistrationIdentificationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usrpb.SaveRegistrationIdentificationRequest}
 */
proto.usrpb.SaveRegistrationIdentificationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.usrpb.RegistrationIdentification;
      reader.readMessage(value,proto.usrpb.RegistrationIdentification.deserializeBinaryFromReader);
      msg.setPrimaryOwner(value);
      break;
    case 2:
      var value = new proto.usrpb.RegistrationIdentification;
      reader.readMessage(value,proto.usrpb.RegistrationIdentification.deserializeBinaryFromReader);
      msg.addCorpOwners(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usrpb.SaveRegistrationIdentificationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usrpb.SaveRegistrationIdentificationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usrpb.SaveRegistrationIdentificationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.SaveRegistrationIdentificationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrimaryOwner();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.usrpb.RegistrationIdentification.serializeBinaryToWriter
    );
  }
  f = message.getCorpOwnersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.usrpb.RegistrationIdentification.serializeBinaryToWriter
    );
  }
};


/**
 * optional RegistrationIdentification primary_owner = 1;
 * @return {?proto.usrpb.RegistrationIdentification}
 */
proto.usrpb.SaveRegistrationIdentificationRequest.prototype.getPrimaryOwner = function() {
  return /** @type{?proto.usrpb.RegistrationIdentification} */ (
    jspb.Message.getWrapperField(this, proto.usrpb.RegistrationIdentification, 1));
};


/**
 * @param {?proto.usrpb.RegistrationIdentification|undefined} value
 * @return {!proto.usrpb.SaveRegistrationIdentificationRequest} returns this
*/
proto.usrpb.SaveRegistrationIdentificationRequest.prototype.setPrimaryOwner = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.usrpb.SaveRegistrationIdentificationRequest} returns this
 */
proto.usrpb.SaveRegistrationIdentificationRequest.prototype.clearPrimaryOwner = function() {
  return this.setPrimaryOwner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.usrpb.SaveRegistrationIdentificationRequest.prototype.hasPrimaryOwner = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated RegistrationIdentification corp_owners = 2;
 * @return {!Array<!proto.usrpb.RegistrationIdentification>}
 */
proto.usrpb.SaveRegistrationIdentificationRequest.prototype.getCorpOwnersList = function() {
  return /** @type{!Array<!proto.usrpb.RegistrationIdentification>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.usrpb.RegistrationIdentification, 2));
};


/**
 * @param {!Array<!proto.usrpb.RegistrationIdentification>} value
 * @return {!proto.usrpb.SaveRegistrationIdentificationRequest} returns this
*/
proto.usrpb.SaveRegistrationIdentificationRequest.prototype.setCorpOwnersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.usrpb.RegistrationIdentification=} opt_value
 * @param {number=} opt_index
 * @return {!proto.usrpb.RegistrationIdentification}
 */
proto.usrpb.SaveRegistrationIdentificationRequest.prototype.addCorpOwners = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.usrpb.RegistrationIdentification, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.usrpb.SaveRegistrationIdentificationRequest} returns this
 */
proto.usrpb.SaveRegistrationIdentificationRequest.prototype.clearCorpOwnersList = function() {
  return this.setCorpOwnersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usrpb.SaveRegistrationTradingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.usrpb.SaveRegistrationTradingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usrpb.SaveRegistrationTradingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.SaveRegistrationTradingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    marginType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    stocks: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    option: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    privacyConsent: jspb.Message.getFieldWithDefault(msg, 4, ""),
    accreditedInvestor: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    marginAgreement: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    marginDisclosure: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usrpb.SaveRegistrationTradingRequest}
 */
proto.usrpb.SaveRegistrationTradingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usrpb.SaveRegistrationTradingRequest;
  return proto.usrpb.SaveRegistrationTradingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usrpb.SaveRegistrationTradingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usrpb.SaveRegistrationTradingRequest}
 */
proto.usrpb.SaveRegistrationTradingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarginType(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStocks(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOption(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrivacyConsent(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAccreditedInvestor(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMarginAgreement(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMarginDisclosure(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usrpb.SaveRegistrationTradingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usrpb.SaveRegistrationTradingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usrpb.SaveRegistrationTradingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.SaveRegistrationTradingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMarginType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStocks();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getOption();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getPrivacyConsent();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAccreditedInvestor();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getMarginAgreement();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getMarginDisclosure();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional string margin_type = 1;
 * @return {string}
 */
proto.usrpb.SaveRegistrationTradingRequest.prototype.getMarginType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.SaveRegistrationTradingRequest} returns this
 */
proto.usrpb.SaveRegistrationTradingRequest.prototype.setMarginType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool stocks = 2;
 * @return {boolean}
 */
proto.usrpb.SaveRegistrationTradingRequest.prototype.getStocks = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.usrpb.SaveRegistrationTradingRequest} returns this
 */
proto.usrpb.SaveRegistrationTradingRequest.prototype.setStocks = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool option = 3;
 * @return {boolean}
 */
proto.usrpb.SaveRegistrationTradingRequest.prototype.getOption = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.usrpb.SaveRegistrationTradingRequest} returns this
 */
proto.usrpb.SaveRegistrationTradingRequest.prototype.setOption = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string privacy_consent = 4;
 * @return {string}
 */
proto.usrpb.SaveRegistrationTradingRequest.prototype.getPrivacyConsent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.SaveRegistrationTradingRequest} returns this
 */
proto.usrpb.SaveRegistrationTradingRequest.prototype.setPrivacyConsent = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool accredited_investor = 5;
 * @return {boolean}
 */
proto.usrpb.SaveRegistrationTradingRequest.prototype.getAccreditedInvestor = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.usrpb.SaveRegistrationTradingRequest} returns this
 */
proto.usrpb.SaveRegistrationTradingRequest.prototype.setAccreditedInvestor = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool margin_agreement = 6;
 * @return {boolean}
 */
proto.usrpb.SaveRegistrationTradingRequest.prototype.getMarginAgreement = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.usrpb.SaveRegistrationTradingRequest} returns this
 */
proto.usrpb.SaveRegistrationTradingRequest.prototype.setMarginAgreement = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool margin_disclosure = 7;
 * @return {boolean}
 */
proto.usrpb.SaveRegistrationTradingRequest.prototype.getMarginDisclosure = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.usrpb.SaveRegistrationTradingRequest} returns this
 */
proto.usrpb.SaveRegistrationTradingRequest.prototype.setMarginDisclosure = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usrpb.SaveRegistrationDisclosureRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.usrpb.SaveRegistrationDisclosureRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usrpb.SaveRegistrationDisclosureRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.SaveRegistrationDisclosureRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    isAccepted: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usrpb.SaveRegistrationDisclosureRequest}
 */
proto.usrpb.SaveRegistrationDisclosureRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usrpb.SaveRegistrationDisclosureRequest;
  return proto.usrpb.SaveRegistrationDisclosureRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usrpb.SaveRegistrationDisclosureRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usrpb.SaveRegistrationDisclosureRequest}
 */
proto.usrpb.SaveRegistrationDisclosureRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAccepted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usrpb.SaveRegistrationDisclosureRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usrpb.SaveRegistrationDisclosureRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usrpb.SaveRegistrationDisclosureRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.SaveRegistrationDisclosureRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIsAccepted();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.usrpb.SaveRegistrationDisclosureRequest.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.SaveRegistrationDisclosureRequest} returns this
 */
proto.usrpb.SaveRegistrationDisclosureRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool is_accepted = 2;
 * @return {boolean}
 */
proto.usrpb.SaveRegistrationDisclosureRequest.prototype.getIsAccepted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.usrpb.SaveRegistrationDisclosureRequest} returns this
 */
proto.usrpb.SaveRegistrationDisclosureRequest.prototype.setIsAccepted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usrpb.SignRegistrationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.usrpb.SignRegistrationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usrpb.SignRegistrationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.SignRegistrationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    imgSignature: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usrpb.SignRegistrationRequest}
 */
proto.usrpb.SignRegistrationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usrpb.SignRegistrationRequest;
  return proto.usrpb.SignRegistrationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usrpb.SignRegistrationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usrpb.SignRegistrationRequest}
 */
proto.usrpb.SignRegistrationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setImgSignature(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usrpb.SignRegistrationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usrpb.SignRegistrationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usrpb.SignRegistrationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.SignRegistrationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImgSignature();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string img_signature = 1;
 * @return {string}
 */
proto.usrpb.SignRegistrationRequest.prototype.getImgSignature = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.SignRegistrationRequest} returns this
 */
proto.usrpb.SignRegistrationRequest.prototype.setImgSignature = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usrpb.GetRegistrationAccountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.usrpb.GetRegistrationAccountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usrpb.GetRegistrationAccountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.GetRegistrationAccountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usrpb.GetRegistrationAccountRequest}
 */
proto.usrpb.GetRegistrationAccountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usrpb.GetRegistrationAccountRequest;
  return proto.usrpb.GetRegistrationAccountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usrpb.GetRegistrationAccountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usrpb.GetRegistrationAccountRequest}
 */
proto.usrpb.GetRegistrationAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usrpb.GetRegistrationAccountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usrpb.GetRegistrationAccountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usrpb.GetRegistrationAccountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.GetRegistrationAccountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 account_id = 1;
 * @return {number}
 */
proto.usrpb.GetRegistrationAccountRequest.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.GetRegistrationAccountRequest} returns this
 */
proto.usrpb.GetRegistrationAccountRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usrpb.SaveRegistrationKycRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.usrpb.SaveRegistrationKycRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usrpb.SaveRegistrationKycRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.SaveRegistrationKycRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    ownerId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    kycStatus: jspb.Message.getFieldWithDefault(msg, 2, ""),
    primaryOwner: (f = msg.getPrimaryOwner()) && proto.usrpb.RegistrationIdentification.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usrpb.SaveRegistrationKycRequest}
 */
proto.usrpb.SaveRegistrationKycRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usrpb.SaveRegistrationKycRequest;
  return proto.usrpb.SaveRegistrationKycRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usrpb.SaveRegistrationKycRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usrpb.SaveRegistrationKycRequest}
 */
proto.usrpb.SaveRegistrationKycRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOwnerId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setKycStatus(value);
      break;
    case 3:
      var value = new proto.usrpb.RegistrationIdentification;
      reader.readMessage(value,proto.usrpb.RegistrationIdentification.deserializeBinaryFromReader);
      msg.setPrimaryOwner(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usrpb.SaveRegistrationKycRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usrpb.SaveRegistrationKycRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usrpb.SaveRegistrationKycRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.SaveRegistrationKycRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOwnerId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getKycStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPrimaryOwner();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.usrpb.RegistrationIdentification.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 owner_id = 1;
 * @return {number}
 */
proto.usrpb.SaveRegistrationKycRequest.prototype.getOwnerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.SaveRegistrationKycRequest} returns this
 */
proto.usrpb.SaveRegistrationKycRequest.prototype.setOwnerId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string kyc_status = 2;
 * @return {string}
 */
proto.usrpb.SaveRegistrationKycRequest.prototype.getKycStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.SaveRegistrationKycRequest} returns this
 */
proto.usrpb.SaveRegistrationKycRequest.prototype.setKycStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional RegistrationIdentification primary_owner = 3;
 * @return {?proto.usrpb.RegistrationIdentification}
 */
proto.usrpb.SaveRegistrationKycRequest.prototype.getPrimaryOwner = function() {
  return /** @type{?proto.usrpb.RegistrationIdentification} */ (
    jspb.Message.getWrapperField(this, proto.usrpb.RegistrationIdentification, 3));
};


/**
 * @param {?proto.usrpb.RegistrationIdentification|undefined} value
 * @return {!proto.usrpb.SaveRegistrationKycRequest} returns this
*/
proto.usrpb.SaveRegistrationKycRequest.prototype.setPrimaryOwner = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.usrpb.SaveRegistrationKycRequest} returns this
 */
proto.usrpb.SaveRegistrationKycRequest.prototype.clearPrimaryOwner = function() {
  return this.setPrimaryOwner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.usrpb.SaveRegistrationKycRequest.prototype.hasPrimaryOwner = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usrpb.CorpAttachments.prototype.toObject = function(opt_includeInstance) {
  return proto.usrpb.CorpAttachments.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usrpb.CorpAttachments} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.CorpAttachments.toObject = function(includeInstance, msg) {
  var f, obj = {
    requiredAttachment: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fileName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    id: jspb.Message.getFieldWithDefault(msg, 3, 0),
    tag: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usrpb.CorpAttachments}
 */
proto.usrpb.CorpAttachments.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usrpb.CorpAttachments;
  return proto.usrpb.CorpAttachments.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usrpb.CorpAttachments} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usrpb.CorpAttachments}
 */
proto.usrpb.CorpAttachments.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequiredAttachment(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usrpb.CorpAttachments.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usrpb.CorpAttachments.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usrpb.CorpAttachments} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.CorpAttachments.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequiredAttachment();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getTag();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string required_attachment = 1;
 * @return {string}
 */
proto.usrpb.CorpAttachments.prototype.getRequiredAttachment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.CorpAttachments} returns this
 */
proto.usrpb.CorpAttachments.prototype.setRequiredAttachment = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_name = 2;
 * @return {string}
 */
proto.usrpb.CorpAttachments.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.CorpAttachments} returns this
 */
proto.usrpb.CorpAttachments.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 id = 3;
 * @return {number}
 */
proto.usrpb.CorpAttachments.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.usrpb.CorpAttachments} returns this
 */
proto.usrpb.CorpAttachments.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string tag = 4;
 * @return {string}
 */
proto.usrpb.CorpAttachments.prototype.getTag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.usrpb.CorpAttachments} returns this
 */
proto.usrpb.CorpAttachments.prototype.setTag = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.usrpb.CorpAttachmentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usrpb.CorpAttachmentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.usrpb.CorpAttachmentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usrpb.CorpAttachmentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.CorpAttachmentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    corpAttachmentsList: jspb.Message.toObjectList(msg.getCorpAttachmentsList(),
    proto.usrpb.CorpAttachments.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usrpb.CorpAttachmentsResponse}
 */
proto.usrpb.CorpAttachmentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usrpb.CorpAttachmentsResponse;
  return proto.usrpb.CorpAttachmentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usrpb.CorpAttachmentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usrpb.CorpAttachmentsResponse}
 */
proto.usrpb.CorpAttachmentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.usrpb.CorpAttachments;
      reader.readMessage(value,proto.usrpb.CorpAttachments.deserializeBinaryFromReader);
      msg.addCorpAttachments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usrpb.CorpAttachmentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usrpb.CorpAttachmentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usrpb.CorpAttachmentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usrpb.CorpAttachmentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCorpAttachmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.usrpb.CorpAttachments.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CorpAttachments corp_attachments = 1;
 * @return {!Array<!proto.usrpb.CorpAttachments>}
 */
proto.usrpb.CorpAttachmentsResponse.prototype.getCorpAttachmentsList = function() {
  return /** @type{!Array<!proto.usrpb.CorpAttachments>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.usrpb.CorpAttachments, 1));
};


/**
 * @param {!Array<!proto.usrpb.CorpAttachments>} value
 * @return {!proto.usrpb.CorpAttachmentsResponse} returns this
*/
proto.usrpb.CorpAttachmentsResponse.prototype.setCorpAttachmentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.usrpb.CorpAttachments=} opt_value
 * @param {number=} opt_index
 * @return {!proto.usrpb.CorpAttachments}
 */
proto.usrpb.CorpAttachmentsResponse.prototype.addCorpAttachments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.usrpb.CorpAttachments, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.usrpb.CorpAttachmentsResponse} returns this
 */
proto.usrpb.CorpAttachmentsResponse.prototype.clearCorpAttachmentsList = function() {
  return this.setCorpAttachmentsList([]);
};


goog.object.extend(exports, proto.usrpb);
